import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faFacebook, 
    faTwitter, 
    faLinkedin, 
    faYoutube 
} from '@fortawesome/free-brands-svg-icons';
import { 
    faPhone, 
    faEnvelope, 
    faMapMarkerAlt 
} from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
    return (
        <footer className="bg-dark text-light pt-5 pb-3 mt-5">
            <Container>
                <Row className="pb-4">
                    <Col md={4} className="mb-4 mb-md-0">
                        <h5 className="fw-bold mb-3">Indian News Paper & Media Association</h5>
                        <p>
                            Empowering media professionals since 1990. 
                            Committed to excellence in journalism and media practice.
                        </p>
                        <div className="social-links mt-3">
                            <a href="#" className="text-light me-3">
                                <FontAwesomeIcon icon={faFacebook} size="lg" />
                            </a>
                            <a href="#" className="text-light me-3">
                                <FontAwesomeIcon icon={faTwitter} size="lg" />
                            </a>
                            <a href="#" className="text-light me-3">
                                <FontAwesomeIcon icon={faLinkedin} size="lg" />
                            </a>
                            <a href="#" className="text-light">
                                <FontAwesomeIcon icon={faYoutube} size="lg" />
                            </a>
                        </div>
                    </Col>
                    
                    <Col md={3} className="mb-4 mb-md-0">
                        <h5 className="fw-bold mb-3">Quick Links</h5>
                        <ul className="list-unstyled">
                            <li><Link to="/" className="text-light text-decoration-none">Home</Link></li>
                            <li><Link to="/about" className="text-light text-decoration-none">About Us</Link></li>
                            <li><Link to="/membership" className="text-light text-decoration-none">Membership</Link></li>
                            <li><Link to="/members" className="text-light text-decoration-none">Members</Link></li>
                            <li><Link to="/contact" className="text-light text-decoration-none">Contact</Link></li>
                        </ul>
                    </Col>
                    
                    <Col md={2} className="mb-4 mb-md-0">
                        <h5 className="fw-bold mb-3">Legal</h5>
                        <ul className="list-unstyled">
                            <li><Link to="/privacy" className="text-light text-decoration-none">Privacy Policy</Link></li>
                            <li><Link to="/terms" className="text-light text-decoration-none">Terms & Conditions</Link></li>
                            <li><Link to="/refund" className="text-light text-decoration-none">Refund Policy</Link></li>
                        </ul>
                    </Col>
                    
                    <Col md={3}>
                        <h5 className="fw-bold mb-3">Contact</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2">
                                <FontAwesomeIcon icon={faPhone} className="me-2" />
                                +91 95351 50008
                            </li>
                            <li className="mb-2">
                                <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                info@mediaassociation.co.in
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                                #65, 3rd Floor, SSR Archade,
Gandhi Bazaar Main Road,
Basavanagudi, Bangalore, Karnataka - 560004
                            </li>
                        </ul>
                    </Col>
                </Row>
                
                <Row>
                    <Col className="text-center pt-3 border-top border-secondary">
                        <p className="mb-0">
                            © {new Date().getFullYear()} Indian News Paper & Media Association. 
                            All Rights Reserved.
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;